import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const user = JSON.parse(localStorage.getItem("user"));

const initialState = {
  user: user ? user : null,
  isLoading: null,
  isError: null,
  users: null,
  isRegisterLoading: null,
  isRegisterSuccess: null,
  isUpdateSuccess: null,
  isDeleteSuccess: null,
};

export const registerUser = createAsyncThunk(
  "user/registerUser",
  async ({ user, config }, thunkApi) => {
    try {
      const response = await axios.post("/api/users", user, config);
      return response.status === "201" && { success: true };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
  }
);
export const editUserAsync = createAsyncThunk(
  "user/editUserAsync",
  async ({ user, config }, thunkApi) => {
    try {
      const response = await axios.put(
        `/api/users/${user._id.toString()}`,
        user,
        config
      );
      return response.status === "200" && { success: true };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
  }
);
export const deleteUserAsync = createAsyncThunk(
  "user/deleteUserAsync",
  async (id, thunkApi) => {
    const { token } = thunkApi.getState().users.user;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const response = await axios.delete(`/api/users/${id}`, config);
      return response.status === "200" && { success: true };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
  }
);
export const userLoginAsync = createAsyncThunk(
  "user/userLoginAsync",
  async ({ email, password }, thunkApi) => {
    try {
      const response = await axios.post("/api/users/login", {
        email,
        password,
      });
      response?.data &&
        localStorage.setItem("user", JSON.stringify(response.data));
      const user = response?.data;
      return { user };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
  }
);
export const getUserListAsync = createAsyncThunk(
  "user/getUserListAsync",
  async (data, thunkApi) => {
    try {
      const { token } = thunkApi.getState().users.user;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.get(
        `/api/users?pageNumber=${data.pageNumber}`,
        config
      );
      const { users, pages, page } = response.data && response.data;
      return { users, pages, page };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    reset: (state) => {
      state.user = null;
      state.isLoading = null;
      state.isError = null;
      state.users = null;
    },
    logout: (state) => {
      state.user = null;
      state.isLoading = null;
      state.isError = null;
      state.users = null;
      localStorage.removeItem("user");
    },
  },
  extraReducers: {
    [userLoginAsync.pending]: (state, action) => {
      state.isLoading = true;
    },
    [userLoginAsync.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.user = action.payload.user;
    },
    [userLoginAsync.rejected]: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload.message;
      state.user = null;
    },
    [registerUser.pending]: (state, action) => {
      state.isRegisterLoading = true;
      state.isRegisterSuccess = false;
    },
    [registerUser.fulfilled]: (state, action) => {
      state.isRegisterLoading = false;
      state.isRegisterSuccess = true;
    },
    [registerUser.rejected]: (state, action) => {
      state.isRegisterLoading = false;
      state.isRegisterSuccess = false;
      state.isError = true;
    },
    [getUserListAsync.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getUserListAsync.fulfilled]: (state, action) => {
      state.isRegisterSuccess = null;
      state.isUpdateSuccess = null;
      state.isDeleteSuccess = null;
      state.isLoading = false;

      state.users = action.payload.users;
      state.pages = action.payload.pages;
      state.page = action.payload.page;
    },
    [getUserListAsync.rejected]: (state, action) => {
      state.isRegisterSuccess = null;
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload.message;
      state.users = null;
    },
    [editUserAsync.pending]: (state, action) => {
      state.isLoading = true;
    },
    [editUserAsync.fulfilled]: (state, action) => {
      state.isUpdateSuccess = true;
      state.isLoading = false;
    },
    [editUserAsync.rejected]: (state, action) => {
      state.isUpdateSuccess = null;
      state.isError = true;
      state.message = action.payload.message;
    },
    [deleteUserAsync.pending]: (state, action) => {
      state.isLoading = true;
    },
    [deleteUserAsync.fulfilled]: (state, action) => {
      state.isDeleteSuccess = true;
      state.isLoading = false;
    },
    [deleteUserAsync.rejected]: (state, action) => {
      state.isDeleteSuccess = null;
      state.isError = true;
      state.message = action.payload.message;
    },
  },
});
export const { reset, logout } = userSlice.actions;
export default userSlice.reducer;
